<template>
  <div id="main-wrap">
    <div id="main">
      <div
        :style="{
          height: `100vh`,
          overflow: 'hidden'
        }"
      >
        <div
          :style="{
            height: bodyHeight || '1620px',
            'transformOrigin':'left top',
            'transform':`scale(${scalseNum})`,
            '-webkit-transform':`scale(${scalseNum})`,
            '-moz-transform':`scale(${scalseNum})`,
            '-o-transform':`scale(${scalseNum})`,
            '-ms-transform':`scale(${scalseNum})`
          }"
        >
          <div id="CoolSuperScreen">
            <div class="screen-wrap">
              <div class="screen-1">
                <!-- <div class="hd">
              <p class="title">酷开-交互无界</p>
            </div> -->
                <div class="screen-1__content">
                  <ScreenFirst :data="ScreenFirstData"></ScreenFirst>
                </div>
              </div>
              <div class="screen-2">
                <!-- <div class="hd">
              <p class="title">酷开-交互无界</p>
            </div> -->
                <div class="screen-2__content">
                  <ScreenSecond :screen-second-data="ScreenSecondData"></ScreenSecond>
                </div>
              </div>
              <div class="screen-3">
                <!-- <div class="hd">
              <p class="title">酷开-交互无界</p>
            </div> -->
                <div class="screen-3__content">
                  <ScreenThree :data="ScreenThreeData"></ScreenThree>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ccMapMixin from '@/mixins/ccmap'
import common from '@/mixins/common.js'
import scalseNum from '@/mixins/scalseNum.js'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import ScreenFirst from '@/components/CoolSuperScreen/ScreenFirst'
import ScreenSecond from '@/components/CoolSuperScreen/ScreenSecond'
import ScreenThree from '@/components/CoolSuperScreen/ScreenThree'
// import { option } from './js/test'
import axios from 'axios'
export default {
  mixins: [ccMapMixin, common],
  name: 'CoolSuperScreen',
  components: {
    DomeEchartWrap,
    ScreenFirst,
    ScreenSecond,
    ScreenThree
  },
  props: {},
  data () {
    return {
      scalseNum: 1,
      pagesHeight: 'auto',
      ScreenFirstData: {},
      ScreenSecondData: {},
      ScreenThreeData: {}
    }
  },
  computed: {
    bodyHeight () {
      return this.$route.meta.bodyHeight || null
    }
  },
  created () {
    this.resize_window()
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.resize_window()
    })
    this.getSuperScreenData()
  },
  watch: {

  },
  methods: {
    resize_window () {
      const width = document.documentElement.clientWidth
      const scalseNum = Number(width / 7680)
      this.scalseNum = scalseNum
      this.pagesHeight = this.bodyHeight || (1620 * scalseNum)
    },
    getSuperScreenData () {
      this.$service.fetch({
        method: 'get',
        url: '/api/unbounded/dashboard'
      }).then(res => {
        let { livingRoomVo, voiceVO, operationVO, digitalMarketingVO, unboundedMiiteeVO, worldVO } = res
        this.ScreenThreeData = {
          livingRoomVo, operationVO, digitalMarketingVO
        }
        this.ScreenFirstData = {
          voiceVO, unboundedMiiteeVO
        }
        this.ScreenSecondData = {
          worldVO
        }
      })
    }
  }
}
</script>
<style scoped>
#CoolSuperScreen>>>*{
  box-sizing: border-box;
}
</style>
<style scoped lang="stylus">
@import '~@/assets/font/BoldAlternate.css';

#main-wrap
  width 100vw
  height 100vh
  overflow auto
#main
  transform-origin: left top;

#CoolSuperScreen
  height 1620px
  padding 2rem
  width 7680px
  box-sizing: border-box
  background-color: #0C1117
  >>> .unit-body
        overflow: auto
        background-color: RGBA(255, 255, 255, 0.05)
  >>> .unit-header
        font-size: 1.52rem
        padding-left: 1rem
        height 3rem
        line-height: 3rem
        background-color: rgba(255, 255, 255, 0.1)
  .screen-wrap
    display flex
    justify-content: space-between
    height 100%
    align-items: center
  >>> .BoldAlternate
        font-family:emoji
.screen-1,.screen-2,.screen-3
  width 125rem
  height 100%
  overflow hidden
.hd
  margin-bottom: 1.6rem
  .title
    font-size: 2.2rem
    color: #fff
.screen-2
  display flex
  flex-direction: column
.screen-2__content
  height: 100%
  width 100%
</style>
